import WheeWave from "./WheeWave";

export default WheeWave;
